import { render, staticRenderFns } from "./SavedMoniesByMonth.vue?vue&type=template&id=829c9bd2"
import script from "./SavedMoniesByMonth.vue?vue&type=script&lang=js"
export * from "./SavedMoniesByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports